import AbstractBaseError from './AbstractBaseError';

export default class HttpException extends AbstractBaseError {
	name = 'HttpException';

	constructor(
		protected response: Response,
		message: string,
		protected previousError?: Error
	) {
		super(message);
	}

	getResponse() {
		return this.response;
	}

	getPreviousError() {
		return this.previousError;
	}
}
